import { Card, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import React, { FunctionComponent, useEffect } from 'react';
import { filterNumber } from '../lib/filterNumber';

interface Props {
  companyName: string;
  companyNo: string;
  officeNo: string;
  setCompanyName: React.Dispatch<React.SetStateAction<string>>;
  setCompanyNo: React.Dispatch<React.SetStateAction<string>>;
  setOfficeNo: React.Dispatch<React.SetStateAction<string>>;
}

const CompanyOfficeForm: FunctionComponent<Props> = ({ companyName, companyNo, officeNo, setCompanyName, setCompanyNo, setOfficeNo }) => {
  const handleChangeCompanyNo = (value: string) => {
    setCompanyNo(filterNumber(value));
  };

  const handleChangeOfficeNo = (value: string) => {
    setOfficeNo(filterNumber(value));
  };

  useEffect(() => {
    setCompanyName(localStorage.getItem('companyName') ?? '');
    setCompanyNo(localStorage.getItem('companyNo') ?? '');
    setOfficeNo(localStorage.getItem('officeNo') ?? '');
  }, [setCompanyName, setCompanyNo, setOfficeNo]);

  return (
    <Box>
      <Typography color="text.primary" variant="h6" gutterBottom>
        企業情報
      </Typography>

      <Box>
        <Card variant="outlined">
          <CardContent>
            <Box className="flex flex-col gap-y-3">
              <TextField
                className="w-1/2"
                label="企業名"
                value={companyName}
                variant="outlined"
                onChange={e => setCompanyName(e.target.value)}
              />
              <TextField
                className="w-1/2"
                label="企業No(半角数字4桁)"
                value={companyNo}
                variant="outlined"
                onChange={e => handleChangeCompanyNo(e.target.value)}
              />
              <TextField
                className="w-1/2"
                label="事業所番号(半角数字)"
                value={officeNo}
                variant="outlined"
                onChange={e => handleChangeOfficeNo(e.target.value)}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export { CompanyOfficeForm };
